





























import Vue from 'vue';

import ShowCardItem from './show-card-item.vue';
import { IShow } from '../../../../../shared/types';

interface IData {
  editedShows: IShow[];
}

interface IMethods {
}

interface IComputed {
}

interface IProps {
  title: string;
  shows: IShow[];
  rows: boolean;
  category: boolean;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'ShowCards',

  components: {
    ShowCardItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    category: {
      type: Boolean,
      default: false,
    },

    shows: {
      type: Array,
      default: () => [] as IShow[],
    },

    rows: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    handleRemove(id: number) {
      this.$emit('remove', id);
    },
  },
});
